import Img from "gatsby-image"
import React, { useContext } from "react"
import { css } from "styled-components"
import Block from "../../../design-system/atoms/layout-primitives/block"
import Spacer from "../../../design-system/atoms/layout-primitives/spacer"
import { T } from "../../../design-system/atoms/text"
import {
  FadeIn,
  FadeInBottom,
} from "../../../design-system/styles/animations.styles"
import Grid from "../grid"
import usePlatformBlocks from "../hooks/usePlatformBlocks"
import { UIContext } from "../layout"
import Breakpoints from "../breakpoints"

export default function LayersBanner() {
  const {
    state: { disableAnimations },
  } = useContext(UIContext)

  const platformBlocks = usePlatformBlocks()

  return (
    <>
      <Spacer height={{ md: "16px", lg: "64px" }} />
      <Grid>
        <Block.Animated
          animation={FadeIn}
          disableAnimations={disableAnimations}
          variants={[
            css`
              display: block;
              z-index: 100;
              grid-column: 2/-2;
              grid-row: 1 / 7;
              width: 100%;
              max-width: 328px;
              align-self: start;
              justify-self: center;
            `,
            css`
              grid-column: 4 / -4;
              max-width: 354px;
            `,
            css`
              grid-column: 8/-2;
              grid-row: 1/-1;
              max-width: 443px;
              @media (min-width: ${Breakpoints.lgPlus}) {
                grid-column: 7/-3;
              }
            `,
          ]}
        >
          <Img fluid={platformBlocks.childImageSharp.fluid} />
        </Block.Animated>
        <Block.Animated
          animation={FadeInBottom}
          disableAnimations={disableAnimations}
          variants={[
            css`
              ${T.sm.h2`300`};
              color: var(--slate);
              text-align: center;
              padding: 24px 20px 0 20px;
              grid-column: 1 / -1;
              grid-row: 5 / span 3;
              letter-spacing: 0.05em;
              z-index: 100;
              & > span {
                color: var(--burnt-orange);
                font-weight: 500;
                display: block;
              }
            `,
            css`
              color: var(--slate);
              grid-row: 6;
              padding: 0;
            `,
            css`
              ${T.lg.h2`300`}
              text-align: left;
              grid-column: 2/9;
              grid-row: 1/-1;
              align-self: center;
              justify-self: center;
              & > span {
                display: inline;
              }
              padding-bottom: 96px;
              @media (min-width: ${Breakpoints.lgPlus}) {
                grid-column: 2/7;
              }
            `,
          ]}
        >
          Building a <span>Digital Mapping Experience</span>
        </Block.Animated>
      </Grid>
    </>
  )
}
